import type * as React from 'react'
import { useTranslation } from 'react-i18next'
import { Toaster as Sonner, type ToasterProps } from 'sonner'

// shadcn's generated Toaster reads `theme` from next-themes' `useTheme()`. This is a
// Vite app with no theme provider, so we drop that dependency and hardcode the current
// (light-only) theme. Toast colors still track the app's design tokens via the CSS
// variables below, so this stays correct if a `.dark` toggle is wired up later.
function Toaster({ ...props }: ToasterProps) {
	const { t } = useTranslation()

	return (
		<Sonner
			theme='light'
			position='top-center'
			className='toaster group'
			containerAriaLabel={t('toaster.aria_label')}
			style={
				{
					'--normal-bg': 'var(--popover)',
					'--normal-text': 'var(--popover-foreground)',
					'--normal-border': 'var(--border)',
				} as React.CSSProperties
			}
			{...props}
		/>
	)
}

export { Toaster }
